import { render } from "./LoginReset.vue?vue&type=template&id=8e75298c"
import script from "./LoginReset.vue?vue&type=script&lang=ts"
export * from "./LoginReset.vue?vue&type=script&lang=ts"
script.render = render

export default script